import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Site under construction. Launching 1st Dec 2021.
        </p>
      </header>
    </div>
  );
}

export default App;
